import { makeAutoObservable } from "mobx"

export default class CampaignScenarioActionGroup {

  constructor(campaignScenarioActionGroup = {}) {
    this.id = campaignScenarioActionGroup.id
    this.campaign_scenario_id = campaignScenarioActionGroup.campaign_scenario_id
    this.influencer_id = campaignScenarioActionGroup.influencer_id
    this.advertiser_margin = campaignScenarioActionGroup.advertiser_margin
    this.influencer_payout_margin = campaignScenarioActionGroup.influencer_payout_margin
    this.action_type = campaignScenarioActionGroup.action_type
    this.visible_in_budget = campaignScenarioActionGroup.visible_in_budget !== false
    this.label = campaignScenarioActionGroup.label
    this.reach = campaignScenarioActionGroup.reach
    this.slot_number = campaignScenarioActionGroup.slot_number || 1

    makeAutoObservable(this)
  }
}
